import useGeneralApi from "views/Settings/General/hooks/useGeneralApi";
import useNotification from "utils/hooks/useNotification";
import useFooterStore from "views/hooks/useFooterStore";
import { getFormError } from "utils/getFormError";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const usePaymentForm = (
  nextButton?: () => void,
  isSetup?: boolean,
  form?: any,
  refetch?: any,
) => {
  const { t } = useTranslation();
  const urlParams = useParams();

  const { updateCompanySetting } = useGeneralApi();
  const { notificationSuccessfullySaved } = useNotification();
  const setHandleOkSaveButton = useFooterStore(state => state.setHandleOkSaveButton);
  const setSaveLoading = useFooterStore(state => state.setSaveLoading);

  const onFinishFailed = ({ errorFields }: { errorFields: Array<{ name: (string|number)[]; errors: string[] }> }) => {
    if (errorFields) {
      setHandleOkSaveButton(false);
      setSaveLoading(false);
    }
  };

  const onFinish = async (values: Record<string, any>) => {
    let errors: any = [];
    const responseUpdateCompanySetting = await updateCompanySetting({
      variables: {
        input: {
          id: urlParams.companyId,
          defaultBankAccountId: values?.defaultBankAccountId,
          defaultBankInstitutionId: values?.defaultBankInstitutionId,
          defaultPaymentMethods: values?.defaultPaymentMethods,
        },
      },
    });

    errors = responseUpdateCompanySetting?.data?.updateCompanySetting.errors;

    setSaveLoading(false);

    if (errors && errors.length > 0) {
      const fieldsData = getFormError(errors, values);
      form.setFields(fieldsData);
    } else {
      notificationSuccessfullySaved(t("Payment settings"));
      setHandleOkSaveButton(false);
      nextButton && nextButton();
      refetch?.();
    }
  };

  const handleOk = () => {
    form.submit();
    setSaveLoading(true);
  };

  return {
    form,
    onFinish,
    onFinishFailed,
    handleOk,
    isSetup,
  };
};
